<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          System Level Languages
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addingNewItem">Add New
            Language</vs-button>
        </h3>
        <p class="card-subtitle">
          List of Default Languages to System (Used by - Categories | Posts |
          Tags)
        </p>
        <table class="table">
          <tr>
            <th>#</th>
            <th>Language Name</th>
            <th>Language Culture</th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in all" :key="item.culture">
            <td>{{ index + 1 }}</td>
            <td class="td">
              {{ item.language }}
            </td>
            <td class="td">
              {{ item.culture }}
            </td>
            <td class="td">
              <vs-button class="mr15" size="small" icon="create" color="warning" v-if="checkCulture(item.culture)"
                @click="editingItem(item)">
                Edit
              </vs-button>
              <vs-button class="mr15" size="small" color="danger" icon="delete_sweep" v-if="checkCulture(item.culture)"
                @click="
                  deleteLanguagePopup = true;
                itemToDelete = item;
                ">
                Delete
              </vs-button>
            </td>
          </tr>
        </table>

        <!-- Code -->
        <vs-popup class="holamundo" :title="isNew ? 'Add New Language' : 'Edit Language'" :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Language Name (Keep it Simple and short)" v-model="lang.language" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15">
              <vs-input label="Language Culture (Short Acronym Ex: Hindi - HI)" v-model="lang.culture"
                @keypress.enter="btnAddLanguage" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-button icon="save" @click="btnAddLanguage">Save</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup class="holamundo" title="Delete Language" :active.sync="deleteLanguagePopup">
          <p>Are you sure you want to delete Language?</p>
          <div>
            <vs-button class="mr15" @click="deleteLangauge">Delete Language</vs-button>
            <vs-button @click="deleteLanguagePopup = false">Cancel</vs-button>
          </div>
        </vs-popup>
        <!-- Code -->
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";
import api from "@/rest.js";
import { API } from "@/common/constants";
export default {
  name: "Language",
  components: {
    // uploader
  },
  data: () => ({
    title: "Language",
    defaultalert: false,
    deleteLanguagePopup: false,
    isNew: true,
    lang: {
      language: "",
      culture: "",
    },
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
  }),
  computed: {},
  methods: {
    checkCulture(culture) {
      const unsupportedCultures = ["EN", "HI", "TA", "KN", "TE", "ML", "MR", "BN", "GU", "UR", "OR"];
      return !unsupportedCultures.includes(culture);
    },
    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.lang = {};
    },
    editingItem(i) {
      this.$data.lang = Object.assign({}, i);
      this.$data.defaultalert = true;
      this.$data.isNew = false;
    },
    btnAddLanguage() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      this.$vs.loading();
      let apiToCall = API.INSERT_LANG;
      let data = this.$data.lang;

      if (!this.$data.isNew) {
        apiToCall = API.UPDATE_LANG;

        api.put(`${apiToCall}/${data._id}`, data, { headers })
          .then((r) => {
            this.$vs.loading.close();
            if (r.status === 200) {
              this.$vs.notify({
                title: "Success",
                text: "Updated Successfully",
                color: "success",
                position: "top-right",
              });
              this.$data.isNew = true;
              this.$data.itemToUpdate = "";
              this.$data.defaultalert = false;
              this.$data.lang = {};
              this.fetchAllLanguage();
            } else {
              this.$vs.notify({
                title: "Error",
                text: r.data.error,
                color: "danger",
                position: "top-right",
              });
            }
          });
      } else {
        api
          .post(apiToCall, data, { headers })
          .then((r) => {
            this.$vs.loading.close();
            if (r.status === 200) {
              this.$vs.notify({
                title: "Success",
                text: "Saved Successfully",
                color: "success",
                position: "top-right",
              });
              this.$data.isNew = true;
              this.$data.itemToUpdate = "";
              this.$data.defaultalert = false;
              this.$data.lang = {};
              this.fetchAllLanguage();
            } else {
              this.$vs.notify({
                title: "Error",
                text: r.data.error,
                color: "danger",
                position: "top-right",
              });
            }
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },

    fetchAllLanguage() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.all = r.data;
          if (!r.status == 200) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => { });
    },

    deleteLangauge() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .delete(`${API.DELETE_LANG}/${this.$data.itemToDelete._id}`, this.$data.itemToDelete, { headers })
        .then((r) => {
          if (r.status === 200) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.deleteLanguagePopup = false;
          this.fetchAllLanguage();
        })
        .catch(() => { });
    },
  },
  created() {
    this.fetchAllLanguage();
  },
};
</script>
<style scoped>
.mb15 {
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}
</style>
